import React, { useState, useEffect, useRef } from 'react';
import PropTypes from "prop-types";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import { getUser, getAccessToken, setUserSession } from './service/AuthService';
import { setUserGoal } from './service/GoalService';
import { createEmbeddedCheckoutSession, getStripePublishableKey } from './service/CheckoutService';
import ProblematicLogEntry from './ProblematicLogEntry';
import AudioRecorder from './AudioRecorder'
import Stopwatch from "./Stopwatch";
import Iframe from './Iframe'
import IframeWeb from './IframeWeb'
import Loading from './Loading'
import BrowserNotifications from "./BrowserNotifications";
import { FailureReasonsTextField, TimeSpentSelect, WorkoutTimeSelect, TimeCommitmentSelect, TreatmentsSelect, CaplanScaleNO3Slider, CaplanScaleNO2Slider, CaplanScaleNO1Slider, CaplanScaleCIU3Slider, CaplanScaleCIU2Slider, CaplanScaleCIU1Slider, CaplanScaleCP3Slider, CaplanScaleCP2Slider, CaplanScaleCP1Slider, CaplanScaleMR3Slider, CaplanScaleMR2Slider, CaplanScaleMR1Slider, CaplanScalePOSI1Slider, CaplanScalePOS2Slider, CaplanScalePOS3Slider,  GoalTextField, ProblematicBehaviorsSelect, JoiningReasonSelect, GenderSelect, DOBDatePicker, MateriaBasicTextField, LandingName, MaterialResetPassword, MaterialResetPasswordConfirm } from './MaterialComponents';
import { loadStripe } from '@stripe/stripe-js';
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from '@stripe/react-stripe-js';

import './css/Checkbox.css';
import './css/Daily.css';
import './css/Timeline.css';
import './css/PopupForm.css';
import './css/Success.css';
import './css/Landing.css';

import { OnboardingFriendAdvice, OnboardingGoalsWeek, OnboardingGoalsMonth, OnboardingGoalsQuarter, OnboardingGoalsYear, OnboardingVizSuccess, OnboardingAboutYou} from './MaterialComponents';
import { setOnboardingComplete, updateUser } from './service/AuthService';




//TODO: move this to an environment variable
const onboardingrUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/onboarding';
const registerUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/register';
const loginUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/login';
const API_KEY = process.env.REACT_APP_AWS_API_GATEWAY_KEY || 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB';
const MAILING_LIST_URL = 'https://www.trampolinehealth.co/';
const dateObj = new Date()

const stripePublishableKey = getStripePublishableKey();
const stripePromise = stripePublishableKey ? loadStripe(stripePublishableKey) : null;

//TODO: personalize this and fetch it from the server
function fetchPersonalizedPlan(){
    let html =
    `<strong>Your Personalized Digital Wellness Plan Powered by Trampoline Health</strong><br><br>
Your journey to healthier screen habits starts now. Trampoline Health provides personalized support, relapse prevention,
and community to keep you accountable. The more you engage, the smarter and more accurate your tailored plan becomes.<br><br>
<hr><br>
<strong>1. Understanding Your Digital Habits</strong><br><br>
<strong>Time Impact:</strong> Even small shifts in screen habits can free up more time for focus, relaxation, and
personal growth. As you track more, we’ll provide insights on where time can be reclaimed.<br><br>
<strong>Patterns & Trends:</strong> Tracking your habits will reveal high-risk times, emotional triggers, and usage
spikes—helping you regain control before overuse happens.<br><br>
<strong>Energy & Focus:</strong> Excessive screen time affects mental clarity and motivation. As you engage with the
platform, we’ll pinpoint small changes that boost focus and well-being.<br><br>
<strong>Next Step:</strong> Complete your first Digital Wellness Workout to start identifying patterns and building
healthier habits.<br><br>
<hr><br>
<strong>2. Recognizing Your Triggers</strong><br><br>
<strong>Common Triggers:</strong> Most people overuse screens due to stress, boredom, procrastination, or habit loops.
The more you track, the better we can help you manage your specific triggers.<br><br>
<strong>High-Risk Situations:</strong> Your most vulnerable times—like late nights, social media breaks, or unstructured
moments—will become clearer as you track. Recognizing these patterns is the first step to change.<br><br>
<strong>Device-Specific Risks:</strong> Some platforms are designed to maximize engagement. We’ll help you identify
which apps disrupt your focus the most and how to regain control.<br><br>
<strong>Next Step:</strong> Log your first setback to begin identifying your unique patterns.<br><br>
<hr><br>
<strong>3. Building a Sustainable System</strong><br><br>
<strong>Alternative Activities:</strong><br>
<strong>Boredom:</strong> Read a book, go for a walk, or listen to a podcast.<br>
<strong>Stress Relief:</strong> Practice deep breathing, mindfulness, or stretching.<br>
<strong>Procrastination:</strong> Use a focus timer (like Pomodoro) to stay on track.<br><br>
<strong>Environmental Adjustments:</strong><br>
Keep your phone outside the bedroom at night.<br>
Create a work-only space free from digital distractions.<br><br>
<strong>Accountability & Support:</strong> Join the Trampoline Health Community to ask questions, share progress, and
stay accountable.<br><br>
<strong>Next Step:</strong> Introduce yourself in the Trampoline Health Community and set a personal goal for the
week.<br><br>
<hr><br>
<strong>4. Setting Boundaries That Work</strong><br><br>
<strong>Non-Negotiable Rules:</strong><br>
No screens one hour before bed.<br>
No phone use during meals or social time.<br>
Work-first approach (no social media before finishing key tasks).<br><br>
<strong>Recognizing ‘Stop Signals’:</strong> Signs like guilt, stress, or fatigue after screen overuse mean it’s time to
pause. Logging these moments will help you spot them faster.<br><br>
<strong>Reducing Distractions:</strong><br>
Turn off non-essential notifications.<br>
Move distracting apps off your home screen.<br>
Set up Focus Modes or scheduled "Do Not Disturb" periods.<br><br>
<strong>Next Step:</strong> Set a small boundary goal inside the Trampoline Health community and track your progress
there.<br><br>
<hr><br>
<strong>5. Responding to Setbacks</strong><br><br>
<strong>Recognizing Early Warning Signs:</strong> If you notice anxiety, mindless scrolling, or avoidance behaviors,
it’s time to pause and reflect. Logging these moments will help prevent them from becoming habits.<br><br>
<strong>Adjusting Based on Risk Level:</strong><br>
<strong>Mild distraction:</strong> Take a short break and reset.<br>
<strong>Moderate overuse:</strong> Switch to an alternative activity and note what triggered it.<br>
<strong>Severe habit disruption:</strong> Seek support in the Trampoline Health Community or revisit your
Prevention Plan.<br><br>
<strong>Learning from Relapses:</strong> Every setback is an opportunity to adjust and improve. Tracking them helps you
see progress over time.<br><br>
<strong>Next Step:</strong> Log a recent setback in the app and review your patterns.<br><br>
<hr><br>
<strong>Next Steps with Trampoline Health</strong><br><br>
Your plan evolves with you. The more you engage, the more personalized and effective it becomes.<br><br>
<strong>1. Complete your first Digital Wellness Workout.</strong><br>
Helps you identify patterns and create a personalized improvement plan.<br><br>
<strong>2. Log your first screen time entry or setback.</strong><br>
Real data enables smarter recommendations tailored to your habits.<br><br>
<strong>3. Join the Trampoline Health Community.</strong><br>
Get support, ask questions, and stay accountable in a judgment-free space.<br><br>
<strong>4. Set one clear boundary goal inside the platform.</strong><br>
Small commitments lead to big, sustainable changes.<br><br>
As you continue, Trampoline Health will provide more personalized recommendations, relapse support, and structured
wellness workouts to help you build sustainable, balanced screen habits.<br><br>
    `
    return html
}

const RESULT_HEADING_STYLE = {
    textAlign: 'center',
    color: '#FFFFFF',
    fontFamily: "'Fraunces', serif",
    fontWeight: 300,
    fontSize: 'clamp(2.4rem, 8vw, 3.25rem)',
    lineHeight: 1.1,
    letterSpacing: '-0.02em',
    margin: '0 0 0.55rem',
    textShadow: '0 2px 16px rgba(0, 0, 0, 0.55)',
    paddingBottom: '1rem'
};

function computeOnboardingResults(formData) {
    const timeSpendOptions = ['<3 hours', '3-7 hours', '7-12 hours', '13+ hours '];
    const timeSpendEstimates = [3, 7, 12, 15];
    const timeSpentValue = Array.isArray(formData.timeSpent) ? formData.timeSpent[0] : formData.timeSpent;
    const index = timeSpendOptions.indexOf(timeSpentValue);
    const numTimeSpent = index >= 0 ? timeSpendEstimates[index] : timeSpendEstimates[1];

    const timeSpendYear = Math.ceil((numTimeSpent * 7 * 52) * (1 / 24));
    const lifetimeSpend = Math.ceil(timeSpendYear * 79 * (1 / 365));
    const timeSaved = Math.ceil(lifetimeSpend * 0.3);
    const personalGoal = formData.currentGoal || '';

    const caplanFields = [
        'caplanScalePOSI1', 'caplanScalePOSI2', 'caplanScalePOSI3',
        'caplanScaleMR1', 'caplanScaleMR2', 'caplanScaleMR3',
        'caplanScaleCP1', 'caplanScaleCP2', 'caplanScaleCP3',
        'caplanScaleCIU1', 'caplanScaleCIU2', 'caplanScaleCIU3',
        'caplanScaleNO1', 'caplanScaleNO2', 'caplanScaleNO3',
    ];
    const total = caplanFields.reduce((sum, field) => sum + parseInt(formData[field] || 0, 10), 0);

    const median = 33;
    const std = 17.67;
    let riskFactor = '';
    if (total < (median - std)) {
        riskFactor = 'Low';
    } else if (total >= (median - std) && total < median) {
        riskFactor = 'Medium';
    } else if (total >= median && total < (median + std)) {
        riskFactor = 'High';
    } else if (total >= (median + std)) {
        riskFactor = 'Severe';
    }

    return { timeSpendYear, lifetimeSpend, timeSaved, riskFactor, personalGoal, total };
}



//TODO: move this to an environment variable


const LandingForm = () => {
    const backArrowIcon = (
        <svg width="22" height="22" viewBox="0 0 14 14" fill="none" aria-hidden="true">
            <path
                d="M11 7H3M7 3L3 7l4 4"
                stroke="currentColor"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );

    const nextArrowIcon = (
        <svg width="20" height="20" viewBox="0 0 14 14" fill="none" aria-hidden="true">
            <path
                d="M3 7h8M7 3l4 4-4 4"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );

    

    //Onboarding Log 
    const [onboardingPass, setonboardingPass] = useState('');
    


    //new onboarding screens
    const [onboardingScreenAboutYou, setOnboardingScreenAboutYou] = useState('');
    const [onboardingScreenVizSuccess, setOnboardingScreenVizSuccess] = useState('');
    const [onboardingScreenGoalsYear, setOnboardingScreenGoalsYear] = useState('');
    const [onboardingScreenGoalsThreeMonth, setOnboardingScreenGoalsThreeMonth] = useState('');
    const [onboardingScreenGoalsMonth, setOnboardingScreenGoalsMonth] = useState('');
    const [onboardingScreenGoalsWeek, setOnboardingScreenGoalsWeek] = useState('');
    const [onboardingScreenFriendAdvice, setOnboardingScreenFriendAdvice] = useState('');
    const [relapsePlan, setRelapsePlan] = useState('');
    
    //Relapse Prevention Plan
    const [relapsePlanText, setRelapsePlanText] = useState(fetchPersonalizedPlan());



    const [formData, setFormData] = useState({
        aboutYou: '',
        vizSuccess: '',
        goalsYear: '',
        goalsQuarter: '',
        goalsMonth: '',
        goalsWeek: '',
        friendAdvice: '',
        newPassword: '',
        newPasswordConfirm: '',
        name: '',
        dateofbirth: '',
        gender: '',
        email: '',
        joiningReason: '',
        timeSpent: '',
        problematicBehaviors: 0,
        caplanScalePOSI1: 5,
        caplanScalePOSI2: 5,
        caplanScalePOSI3: 5,
        caplanScaleMR1: 5,
        caplanScaleMR2: 5,
        caplanScaleMR3: 5,
        caplanScaleCP1: 5,
        caplanScaleCP2: 5,
        caplanScaleCP3: 5,
        caplanScaleCIU1: 5,
        caplanScaleCIU2: 5,
        caplanScaleCIU3: 5,
        caplanScaleNO1: 5,
        caplanScaleNO2: 5,
        caplanScaleNO3: 5,
        triedTreatments: '',
        failureReasons: '',
        timeCommitment: '',
        workoutTime: '',
        currentGoal: ''
    });

    const updateFormData = (fields) => {
        setFormData(prev => ({ ...prev, ...fields }));
    };

    const [errors, setErrors] = useState({});
    const [submitError, setSubmitError] = useState(null);
    const [onboardingSubmitStatus, setOnboardingSubmitStatus] = useState('idle'); // idle | pending | success | error
    const onboardingSubmitPromiseRef = useRef(null);
    const accountCreatePromiseRef = useRef(null);
    const checkoutPrefetchPromiseRef = useRef(null);
    const [accountCreated, setAccountCreated] = useState(() => !!getAccessToken());
    const [checkoutClientSecret, setCheckoutClientSecret] = useState(null);
    const [checkoutError, setCheckoutError] = useState(null);
    const [isPrefetchingCheckout, setIsPrefetchingCheckout] = useState(false);

    const clearFieldError = (fieldName) => {
        if (errors[fieldName]) {
            setErrors(prev => ({ ...prev, [fieldName]: undefined }));
        }
    };

    const renderFieldError = (fieldName) => {
        if (!errors[fieldName]) return null;
        return (
            <p
                style={{
                    color: 'rgba(196,90,90,0.9)',
                    fontSize: '11px',
                    marginTop: '6px',
                    fontFamily: 'DM Sans, sans-serif'
                }}
            >
                {errors[fieldName]}
            </p>
        );
    };

    const {
        aboutYou,
        vizSuccess,
        goalsYear,
        goalsQuarter,
        goalsMonth,
        goalsWeek,
        friendAdvice,
        newPassword,
        newPasswordConfirm,
        name,
        dateofbirth,
        gender,
        email,
        joiningReason,
        timeSpent,
        problematicBehaviors,
        caplanScalePOSI1,
        caplanScalePOSI2,
        caplanScalePOSI3,
        caplanScaleMR1,
        caplanScaleMR2,
        caplanScaleMR3,
        caplanScaleCP1,
        caplanScaleCP2,
        caplanScaleCP3,
        caplanScaleCIU1,
        caplanScaleCIU2,
        caplanScaleCIU3,
        caplanScaleNO1,
        caplanScaleNO2,
        caplanScaleNO3,
        triedTreatments,
        failureReasons,
        timeCommitment,
        workoutTime,
        currentGoal
    } = formData;

    function handleAboutYou(newValue) {
        updateFormData({ aboutYou: newValue });
        clearFieldError('aboutYou');
    }
    function handleVizSuccess(newValue) {
        updateFormData({ vizSuccess: newValue });
        clearFieldError('vizSuccess');
    }
    function handleGoalsYear(newValue) {
        updateFormData({ goalsYear: newValue });
    }
    function handleGoalsQuarter(newValue) {
        updateFormData({ goalsQuarter: newValue });
    }
    function handleGoalsMonth(newValue){
        updateFormData({ goalsMonth: newValue });
    }
    function handleGoalsWeek(newValue) {
        updateFormData({ goalsWeek: newValue });
    }
    function handleFriendAdvice(newValue) {
        updateFormData({ friendAdvice: newValue });
        clearFieldError('friendAdvice');
    }
    function handleNewpassword(newValue) {
        updateFormData({ newPassword: newValue });
        clearFieldError('newPassword');
    }
    function handleNewpasswordConfirm(newValue) {
        updateFormData({ newPasswordConfirm: newValue });
        clearFieldError('newPasswordConfirm');
    }


    const [errorMessage, setErrorMessage] = useState('');
    const [isLoading, setLoading] = useState(true);
    const [dailyContent, setDailyContent] = useState('');


    //Popup
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [answers, setAnswers] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [showLearningPopup, setShowLearningPopup] = useState(false);
    const [showonboardingPopup, setShowonboardingPopup] = useState(false);
    
    const [journalAudio, setAudio] = useState(null);

    const navigate = useNavigate()

    //Onboarding Log 
    const [onboardingIntro, setonboardingIntro] = useState('');
    const [onboardingTime, setonboardingTime] = useState('');
    const [onboardingBackground, setonboardingBackground] = useState('');
    const [onboardingInformation, setonboardingInformation] = useState('');
    const [onboardingScreenStart, setOnboardingScreenStart]= useState('');
    const [onboardingWhy, setonboardingWhy] = useState('');
    const [onboardingImpact, setonboardingImpact] = useState('');
    const [onboardingScreen, setOnboardingScreen] = useState('');
    const [onboardingScreen2, setOnboardingScreen2] = useState('');
    const [onboardingScreen3, setOnboardingScreen3] = useState('');
    const [onboardingScreen4, setOnboardingScreen4] = useState('');
    const [onboardingSuccess, setonboardingSuccess] = useState('');
    const [onboardingTimeWasted, setOnboardingTimeWasted] = useState('');
    const [onboardingScreenerResults, setOnboardingScreenerResults] = useState('');
    const [onboardingCalltoAction, setOnboardingCalltoAction] = useState('');



    //Learning Form Data (move it here)
    function handleName(newValue) {
        updateFormData({ name: newValue });
        clearFieldError('name');
    }

    function handleDateofbirth(newValue) {
        updateFormData({ dateofbirth: newValue });
        clearFieldError('dateofbirth');
    }

    function handleGender(newValue) {
        updateFormData({ gender: newValue });
        clearFieldError('gender');
    }

    function handleEmail(newValue) {
        updateFormData({ email: newValue });
        clearFieldError('email');
    }

    function handleJoiningReason(newValue) {
        updateFormData({ joiningReason: newValue });
        clearFieldError('joiningReason');
    }

    function handleTimeSpent(newValue) {
        updateFormData({ timeSpent: newValue });
        clearFieldError('timeSpent');
    }

    function handleProblematicBehaviors(newValue) {
        updateFormData({ problematicBehaviors: newValue });
    }

    function handleCaplanScalePOSI1(newValue) {
        updateFormData({ caplanScalePOSI1: newValue });
    }

    function handleCaplanScalePOSI2(newValue) {
        updateFormData({ caplanScalePOSI2: newValue });
    }

    function handleCaplanScalePOSI3(newValue) {
        updateFormData({ caplanScalePOSI3: newValue });
    }

    function handleCaplanScaleMR1(newValue) {
        updateFormData({ caplanScaleMR1: newValue });
    }

    function handleCaplanScaleMR2(newValue) {
        updateFormData({ caplanScaleMR2: newValue });
        clearFieldError('caplanScaleMR2');
    }

    function handleCaplanScaleMR3(newValue) {
        updateFormData({ caplanScaleMR3: newValue });
        clearFieldError('caplanScaleMR3');
    }

    function handleCaplanScaleCP1(newValue) {
        updateFormData({ caplanScaleCP1: newValue });
    }

    function handleCaplanScaleCP2(newValue) {
        updateFormData({ caplanScaleCP2: newValue });
    }

    function handleCaplanScaleCP3(newValue) {
        updateFormData({ caplanScaleCP3: newValue });
    }

    function handleCaplanScaleCIU1(newValue) {
        updateFormData({ caplanScaleCIU1: newValue });
        clearFieldError('caplanScaleCIU1');
    }

    function handleCaplanScaleCIU2(newValue) {
        updateFormData({ caplanScaleCIU2: newValue });
    }

    function handleCaplanScaleCIU3(newValue) {
        updateFormData({ caplanScaleCIU3: newValue });
        clearFieldError('caplanScaleCIU3');
    }

    function handleCaplanScaleNO1(newValue) {
        updateFormData({ caplanScaleNO1: newValue });
        clearFieldError('caplanScaleNO1');
    }

    function handleCaplanScaleNO2(newValue) {
        updateFormData({ caplanScaleNO2: newValue });
        clearFieldError('caplanScaleNO2');
    }

    function handleCaplanScaleNO3(newValue) {
        updateFormData({ caplanScaleNO3: newValue });
    }

    function handleTriedTreatments(newValue) {
        updateFormData({ triedTreatments: newValue });
        clearFieldError('triedTreatments');
    }

    function handleFailureReasons(newValue) {
        updateFormData({ failureReasons: newValue });
        clearFieldError('failureReasons');
    }

    function handleTimeCommitment(newValue) {
        updateFormData({ timeCommitment: newValue });
        clearFieldError('timeCommitment');
    }

    function handleWorkoutTime(newValue) {
        updateFormData({ workoutTime: newValue });
        clearFieldError('workoutTime');
    }

    function handleCurrentGoal(newValue) {
        updateFormData({ currentGoal: newValue });
        clearFieldError('currentGoal');
    }

    //Onboarding Entries
    const entries = []
    const [entryHTML, setEntryHTML] = useState(null);
    const [lastSubmitDate, setLastSubmitDate] = useState('');
    const [lastTitle, setLastTitle] = useState('');
    const [lastDescription, setLastDescription] = useState('');
    const [lastLesson, setLastLesson] = useState('');
    const [lastImpact, setLastImpact] = useState('');

    //Spinner
    const loadingSpinner = document.querySelector('.donut');

    
    function setOnboardingForm(){
        const { timeSpendYear, lifetimeSpend, timeSaved, personalGoal } = computeOnboardingResults(formData);

        setonboardingIntro(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo" style={{ fontSize:' 0.75em'}}> Trampoline Health is a virtual and physical space for us to <b>build our mental wellness together</b>. To get started, we need to learn a bit about you. Please take a moment to fill out this brief form to help us better understand you. With your help, we can craft the <b>perfect mental wellness program for you</b>! </p>
                </div>
                <div className="formBttnContainer" style={{ bottom:' 5rem'}}>
                    <button className="popupButton" onClick={handleNextQuestion} >Dive in!</button>
                </div>
            </div> 
        )
        setonboardingTime(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo"> Let’s start with learning more about you.  </p>
                </div>
                <div>
                    <div className="onboardingQuestion">Date of Birth:</div>
                    {/* <input type="text" value={morningUse} placeholder="1-10 (1 as in poor 10 as in great)" onChange={event => setMorningUse(event.target.value)} /> <br /> */}
                    <DOBDatePicker handleChange={handleDateofbirth} value={formData.dateofbirth}/>
                    {renderFieldError('dateofbirth')}
                </div>
                <div>
                    <div className="onboardingQuestion">Name:</div>
                    {/* <input type="text" value={morningUse} placeholder="1-10 (1 as in poor 10 as in great)" onChange={event => setMorningUse(event.target.value)} /> <br /> */}
                    <LandingName label="Name" handleChange={handleName} value={formData.name}/>
                    {renderFieldError('name')}
                </div>
                <div>
                    <div className="onboardingQuestion">Gender:</div>
                    <GenderSelect multipleSelect = 'false' label='Gender' elements={['Woman', 'Man', 'Nonbinary', 'Other']} handleChange={handleGender} defaultValue={gender}/>
                    {renderFieldError('gender')}
                </div>

            </div> 
        )
        setonboardingBackground(
            <div className="learningFeedback">
                {/* <div>
                    <p className="questionInfo"> Let's dig a little deeper.</p>
                </div> */}
                <div>
                    {/* <div className="form-group"><label> If you had to pick one current life goal to complete in the next 3 months what would it be?: </label><br /> <input type="text" placeholder='Goal should be Specific, Measurable, Achievable, Relevant, and Time - Bound' value={currentGoal} onChange={event => setCurrentGoal(event.target.value)} /> <br /></div> */}
                    <div className="onboardingQuestion" >What is an important goal that your mental wellness has gotten in the way of?</div>
                    <GoalTextField handleChange={handleCurrentGoal} placeholder='' value={formData.currentGoal}/>
                    {renderFieldError('currentGoal')}
                </div>
                <div>
                    <div className="onboardingQuestion">On a typical day, how many hours do you spend on things that don’t energize or fulfill you?</div>
                    {/* <input type="text" value={morningUse} placeholder="1-10 (1 as in poor 10 as in great)" onChange={event => setMorningUse(event.target.value)} /> <br /> */}
                    <TimeSpentSelect  multipleSelect = 'false' handleChange={handleTimeSpent} label='Time' elements={['<3 hours', '3-7 hours', '7-12 hours', '13+ hours ']} value={formData.timeSpent}/>
                    {renderFieldError('timeSpent')}
                </div>
            </div> 
        )
        setonboardingInformation(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo" style={{ fontSize:' 0.8em'}}>   The following section helps us understand your mental wellness patterns so we can better support your growth.
  Some questions may feel repetitive. That’s intentional. They help us paint a clearer picture.</p>
                    <p className="questionInfo" style={{ fontSize:' 0.8em'}}>  <b>Instructions:</b> Please rate how much you agree with each statement, from 1 (Definitely Disagree) to 8 (Definitely Agree). </p>
                </div>
            </div> 
        )
        setOnboardingScreenStart(
            <div className="learningFeedback">
                <div>
                    <div className="onboardingQuestion">I tend to avoid difficult thoughts or feelings</div>
                    <CaplanScaleMR3Slider handleChange={handleCaplanScaleMR3} min='1' max='8' value={formData.caplanScaleMR3}/>
                    {renderFieldError('caplanScaleMR3')}
                </div>
                <div>
                    <div className="onboardingQuestion">I have missed social engagements or activities because of my mental wellness</div>
                    <CaplanScaleNO2Slider handleChange={handleCaplanScaleNO2} min='1' max='8' value={formData.caplanScaleNO2}/>
                    {renderFieldError('caplanScaleNO2')}
                </div>
                <div>
                    <div className="onboardingQuestion">I struggle to stay present or focused in my day-to-day life</div>
                    <CaplanScaleCIU3Slider handleChange={handleCaplanScaleCIU3} min='1' max='8' value={formData.caplanScaleCIU3}/>
                    {renderFieldError('caplanScaleCIU3')}
                </div>
            </div> 
        )
        setonboardingImpact(
            <div className="learningFeedback">
                <div>
                    <div className="onboardingQuestion">My mental wellness has gotten in the way of showing up how I want to in life.</div>
                    <CaplanScaleCIU1Slider handleChange={handleCaplanScaleCIU1} min='1' max='8' value={formData.caplanScaleCIU1}/>
                    {renderFieldError('caplanScaleCIU1')}
                </div>

                <div>
                    <div className="onboardingQuestion">I find it difficult to regulate my thoughts or emotions when I'm overwhelmed.</div>
                    <CaplanScaleMR2Slider handleChange={handleCaplanScaleMR2} min='1' max='8' value={formData.caplanScaleMR2}/>
                    {renderFieldError('caplanScaleMR2')}
                </div>
                <div>
                    <div className="onboardingQuestion">When I’m down, I often cope in ways that don’t actually help me feel better.</div>
                    <CaplanScaleNO1Slider handleChange={handleCaplanScaleNO1} min='1' max='8' value={formData.caplanScaleNO1}/>
                    {renderFieldError('caplanScaleNO1')}
                </div>
            </div> 
        )
        
        setOnboardingScreen3(
            <div className="learningFeedback">
                <div>
                    <div className="onboardingQuestion">What have you tried?</div>
                    {/* <input type="text" value={morningUse} placeholder="1-10 (1 as in poor 10 as in great)" onChange={event => setMorningUse(event.target.value)} /> <br /> */}
                    <TreatmentsSelect handleChange={handleTriedTreatments} label='Solution(s) - multiple select' elements={['Therapy', 'Journaling', 'Mindfulness', 'Support Group', 'Medication', 'Exercise', 'Nothing Yet', 'Other']} value={formData.triedTreatments}/>
                    {renderFieldError('triedTreatments')}
                </div>
                <div>
                    <div className="onboardingQuestion">What's missing from your mental wellness practice?</div>
                    <FailureReasonsTextField handleChange={handleFailureReasons} placeholder="" rows="2" value={formData.failureReasons}/>
                    {renderFieldError('failureReasons')}
                </div>
            </div> 
        )
        setOnboardingScreen4(
            <div className="learningFeedback">
                <div>
                    <h5 className="questionInfo"> Commit improving your digital use and overall wellness. Let's put in the work.</h5>
                </div>
                <div>
                    <div className="onboardingQuestion"> How many times a week do you commit to work on your digital health?</div>
                    <TimeCommitmentSelect handleChange={handleTimeCommitment} multipleSelect='false' label='Times per Week' elements={['3 times', '5 times', '7 times']} value={formData.timeCommitment}/>
                    {renderFieldError('timeCommitment')}
                </div>
                <div>
                    {/* <div className="form-group"><label> If you had to pick one current life goal to complete in the next 3 months what would it be?: </label><br /> <input type="text" placeholder='Goal should be Specific, Measurable, Achievable, Relevant, and Time - Bound' value={currentGoal} onChange={event => setCurrentGoal(event.target.value)} /> <br /></div> */}
                    <div className="onboardingQuestion"> At what time do you plan to do your workouts?</div>
                    {/* <MateriaBasicTextField handleChange={handleCurrentGoal} placeholder='Goal' /> */}
                    <WorkoutTimeSelect handleChange={handleWorkoutTime} value={formData.workoutTime}/>
                    {renderFieldError('workoutTime')}
                </div>
            </div> 
        )
        // const [onboardingTimeWasted, setOnboardingTimeWasted] = useState('');
        // const [onboardingScreenerResults, setOnboardingScreenerResults] = useState('');
        // const [onboardingCalltoAction, setOnboardingCalltoAction] = useState('');
        setonboardingSuccess(
            <div className="learningFeedback">
                <div>
                    <div style={{ display: 'flex', justifyContent: 'center'}}>
                        <p className="questionInfo"> Mental wellness is is a journey not a destination. Analyzing your responses... </p>
                    </div>
                    {/* <div style={{ marginTop: '5rem'}} id='waiting-animation'>
                        <Loading/>
                    </div> */}
                    <div style={{ marginTop: '5rem', textAlign:'center'}} id='waiting-text' >
                        <h4>Ready to begin? <br></br>Click next to see results 🥳 ✨.</h4>
                    </div>
                </div>
            </div> 
            
        )
        setOnboardingTimeWasted(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo">  We calculated you will spend <b>{timeSpendYear} days this year</b> on things that leave you drained or unfulfilled. Looking ahead this means that you will spend </p>
                    <h1 style={RESULT_HEADING_STYLE}>
                        {lifetimeSpend} years
                    </h1>
                    <p className="questionInfo">  of your life lost to patterns that aren’t serving you. What else could you do in <b>{lifetimeSpend} years</b>?</p>
                </div>
            </div>
        )
        setOnboardingScreenerResults(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo"> Conditions like <b>anxiety, depression, and obesity</b> are more common than ever. It's normal to feel overwhelmed but you can change how you respond. Be more present and build</p>
                    <h1 style={RESULT_HEADING_STYLE}>
                        Resilience
                    </h1>
                    <p className="questionInfo"> at our mental wellness gym. Trampoline Health can help you finally <b>make the change</b>.</p>
                </div>
            </div>
        )
        setOnboardingCalltoAction(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo">  Trampoline can help you recover </p>
                    <h1 style={{ textAlign: 'center'}} >{timeSaved} years +</h1>
                    <p className="questionInfo">  of your life and more importantly help you <b>fill up that time with what matters</b>{personalGoal ? `, like: ${personalGoal.toLowerCase()}` : ''}</p>
                </div>
            </div>
        )


        ////////////////////////////////////////////////////////////// SECONDARY ONBOARDING
        
        //new questions
        setOnboardingScreenAboutYou(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo" style={{ marginBottom: '1rem' }}> Let’s start with learning more about you. </p>
                </div>
                <div>
                    <div className="onboardingQuestion">Tell us about yourself. What background would help us craft your personalized mental wellness plan?</div>
                    <OnboardingAboutYou placeholder="" handleChange={ handleAboutYou } value={formData.aboutYou}/>
                    {renderFieldError('aboutYou')}
                </div>
                <div>
                    <div className="onboardingQuestion">Why do you want to join?</div>
                    {/* <input type="text" value={morningUse} placeholder="1-10 (1 as in poor 10 as in great)" onChange={event => setMorningUse(event.target.value)} /> <br /> */}
                    <JoiningReasonSelect handleChange={handleJoiningReason} label='Where can we help - multiple select' elements={['Decrease Anxiety', 'Improve Well Being ', 'Improve Relationships ', 'Improve Mental Health', 'Improve Physical Health', 'Decrease Loneliness', 'Increase Self-Fulfillment', 'Improve Sleep', 'Improve Productivity']} value={formData.joiningReason}/>
                    {renderFieldError('joiningReason')}
                </div>
            </div> 
        )
        setOnboardingScreenVizSuccess(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo"> Let’s start with learning more about you.  </p>
                </div>
                <div>
                    <div style={{ marginBottom: '1rem' }} className="relapseQuestion">Imagine a life where you are mentally strong and emotionally fit. What does it look like?</div>
                    <OnboardingVizSuccess placeholder="" handleChange={ handleVizSuccess } value={formData.vizSuccess}/>
                    {renderFieldError('vizSuccess')}
                </div>
            </div> 
        )
        
        setOnboardingScreenFriendAdvice(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo"> Sometimes, the best advice we give others is the advice we need ourselves. Reflect on what you'd say to support someone starting their journey. </p>
                </div>
                <div>
                    <div style={{ marginBottom: '1rem' }} className="relapseQuestion">What advice would you give a close friend starting this journey of growth?</div>
                    <OnboardingFriendAdvice placeholder="" handleChange={ handleFriendAdvice } value={formData.friendAdvice}/>
                    {renderFieldError('friendAdvice')}
                </div>
            </div> 
        )

        //separator ----------------

        setonboardingIntro(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo" style={{ fontSize:' 0.75em'}}> We'd love to learn a bit about you and your goals so we can customize your experience. Please take a moment to fill out our quick onboarding form. With your help, we'll craft the perfect program for you!  </p>
                </div>
            </div> 
        )
        setonboardingPass(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo"> Create your account so we can save your plan and start your free trial. </p>
                </div>
                <div>
                    <div className="onboardingQuestion">Email:</div>
                    <MateriaBasicTextField handleChange={handleEmail} placeholder="Email" label="Email" value={formData.email}/>
                    {renderFieldError('email')}
                </div>
                <div>
                    <div className="onboardingQuestion">Password:</div>
                    <MaterialResetPassword handleChange={handleNewpassword} placeholder='Password' value={formData.newPassword}/>
                    {renderFieldError('newPassword')}
                </div>
                <div>
                    <div className="onboardingQuestion">Confirm Password:</div>
                    <MaterialResetPasswordConfirm handleChange={handleNewpasswordConfirm} placeholder='Password' value={formData.newPasswordConfirm}/>
                    {renderFieldError('newPasswordConfirm')}
                </div>
            </div>
        )
     
        setOnboardingScreen4(
            <div className="learningFeedback">
                <div>
                    <h5 className="questionInfo"> Commit improving your emotional fitness and overall wellness. Let's put in the work.</h5>
                </div>
                <div>
                    <div className="onboardingQuestion" style={{ marginBottom: '1rem' }} >How many times a week do you commit to work on your mental wellness?</div>
                    <TimeCommitmentSelect handleChange={handleTimeCommitment} multipleSelect='false' label='Times per Week' elements={['3 times', '5 times', '7 times']} value={formData.timeCommitment}/>
                    {renderFieldError('timeCommitment')}
                </div>
                <div>
                    {/* <div className="form-group"><label> If you had to pick one current life goal to complete in the next 3 months what would it be?: </label><br /> <input type="text" placeholder='Goal should be Specific, Measurable, Achievable, Relevant, and Time - Bound' value={currentGoal} onChange={event => setCurrentGoal(event.target.value)} /> <br /></div> */}
                    <div className="onboardingQuestion" style={{ marginBottom: '1rem' }} >At what time do you plan to do your mental wellness workouts?</div>
                    {/* <MateriaBasicTextField handleChange={handleCurrentGoal} placeholder='Goal' /> */}
                    <WorkoutTimeSelect handleChange={handleWorkoutTime} value={formData.workoutTime}/>
                    {renderFieldError('workoutTime')}
                </div>
            </div> 
        )
        setonboardingSuccess(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo"> Mental wellness is is a journey not a destination. Creating your personalized road map... </p>
                </div>
                <div style={{ marginTop: '5rem'}} >
                    <Loading/>
                </div>
            </div> 
        )
        setRelapsePlan(
            <div className="learningFeedback">
                <div style={{overflowY: "auto", height: "80%", minHeight:"400px", textAlign: "center" }} dangerouslySetInnerHTML={{__html: relapsePlanText}} >
                </div>
                <div className="formBttnContainer" style={{ bottom: '0rem' }}>
                    <button className="popupButton" style={{ marginTop: '1rem' }} onClick={handleCloseRelapsePopup} >Commit To Plan</button>
                </div>
            </div> 
        )

    }



    function stringToHTML (str) {
        // If DOMParser is supported, use it
        let support = true
        if (!window.DOMParser) support = false;
        let parser = new DOMParser();
        try {
            parser.parseFromString('x', 'text/html');
        } catch(err) {
            support = false;
        }
        if (support) {
            let parser = new DOMParser();
            var doc = parser.parseFromString(str, 'text/html');
            //console.log('yo7', dom)
            return doc.body;
        }

        // Otherwise, fallback to old-school method
        var dom = document.createElement('div');
        dom.innerHTML = str;
        //console.log('yooo')
        //console.log('yo7', dom)
        return dom;
    };

    function randomArrVal(arr){
        return arr[Math.floor(Math.random() * arr.length)];
    }
    
    //Popup
    let questionsonboarding = [
        {
            question: "Let's Start Your Mental Wellness Journey!",
            assets: onboardingIntro,
            subheading: 'Test',
            input: '<textarea className="textinput" name="paragraph_text" cols="50" value={contentFeedback} onChange={event => setContentFeedback(event.target.value)}></textarea>'
        },
        {
            question: 'Create Your Account',
            assets: onboardingPass,
            errorMessage: errorMessage
        },
        {
            question: 'Building Your Mental Wellness Plan',
            assets: onboardingTime,
        },
        {
            question: 'Building Your Mental Wellness Plan',
            assets: onboardingBackground,
            answers: gender
        },
        {
            question: 'Building Your Mental Wellness Plan',
            assets: onboardingInformation,
        },
        {
            question: 'Building Your Mental Wellness Plan',
            assets: onboardingScreenStart,
        },
        // {
        //     question: 'Building Your Digital Wellness Plan',
        //     assets: onboardingWhy,
        // },
        {
            question: 'Building Your Mental Wellness Plan',
            assets: onboardingImpact,
        },

        {
            question: 'Building Your Mental Wellness Plan',
            assets: onboardingScreen3,
        },
    
       
        {
            question: 'Getting Started',
            assets: onboardingScreenAboutYou,
        },
        {
            question: 'Getting Started',
            assets: onboardingScreenVizSuccess,
        },

        {
            question: 'Take the First Step',
            assets: onboardingScreenFriendAdvice,
        },
        {
            question: 'Take the First Step',
            assets: onboardingScreen4,
        },

         {
            question: 'Welcome to Trampoline Health',
            assets: onboardingTimeWasted,
        },
        {
            question: 'Welcome to Trampoline Health',
            assets: onboardingScreenerResults,
        },
        {
            question: 'Welcome to Trampoline Health',
            assets: onboardingCalltoAction,
        }
    ];

    const isEmptyValue = (value) => {
        if (Array.isArray(value)) return value.length === 0;
        if (value === null || value === undefined) return true;
        if (typeof value === 'string') return value.trim() === '';
        if (typeof value === 'number') return Number.isNaN(value) || value <= 0;
        return false;
    };

    const getRequiredFieldsForStep = (stepIndex) => {
        const requiredByStep = {
            1: accountCreated ? [] : ['email', 'newPassword', 'newPasswordConfirm'],
            2: ['dateofbirth', 'name', 'gender'],
            3: ['currentGoal', 'timeSpent'],
            5: ['caplanScaleMR3', 'caplanScaleNO2', 'caplanScaleCIU3'],
            6: ['caplanScaleCIU1', 'caplanScaleMR2', 'caplanScaleNO1'],
            7: ['failureReasons', 'triedTreatments'],
            8: ['aboutYou', 'joiningReason'],
            9: ['vizSuccess'],
            10: ['friendAdvice'],
            11: ['timeCommitment', 'workoutTime']
        };
        return requiredByStep[stepIndex] || [];
    };

    const validateStep = (stepIndex) => {
        const nextErrors = {};
        const requiredFields = getRequiredFieldsForStep(stepIndex);

        requiredFields.forEach((field) => {
            if (isEmptyValue(formData[field])) {
                nextErrors[field] = 'This field is required';
            }
        });

        if (stepIndex === 1 && !accountCreated) {
            const emailValue = (formData.email || '').trim();
            if (emailValue && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue)) {
                nextErrors.email = 'Enter a valid email address.';
            }
            if (!isEmptyValue(formData.newPassword) && formData.newPassword.length < 8) {
                nextErrors.newPassword = 'Password must be at least 8 characters.';
            }
            if (formData.newPassword !== formData.newPasswordConfirm) {
                nextErrors.newPasswordConfirm = 'Passwords do not match.';
            }
        }

        setErrors(nextErrors);
        return Object.keys(nextErrors).length === 0;
    };

    const goNext = () => setCurrentQuestion((prev) => prev + 1);
    const goBack = () => setCurrentQuestion((prev) => prev - 1);

    const handleonboardingSupport = () => {
        //console.log('handling onboarding support')
        setShowPopup(true);
        document.getElementById('learning-popup').style.display = "none";
        document.getElementById('onboarding-popup').style.display = "block";
        document.getElementsByClassName("popupContainer")[1].style.visibility =  "visible"
    };

    const registerAndLogin = async () => {
        const requestConfig = {
            headers: {
                'x-api-key': API_KEY
            }
        };

        const trimmedEmail = formData.email.trim();
        const password = formData.newPassword;
        const username = trimmedEmail;
        const registerName = (formData.name || '').trim() || trimmedEmail.split('@')[0] || 'Member';

        try {
            await axios.post(
                registerUrl,
                {
                    username,
                    email: trimmedEmail,
                    name: registerName,
                    password
                },
                requestConfig
            );
        } catch (error) {
            const apiMessage = (error.response?.data?.message || '').toLowerCase();
            const alreadyExists =
                error.response?.status === 401
                && apiMessage.includes('already exists');
            // Re-entering the same email during testing: fall through to login
            if (!alreadyExists) {
                throw error;
            }
        }

        const loginResponse = await axios.post(
            loginUrl,
            { username, password },
            requestConfig
        );

        const { user: loggedInUser } = loginResponse.data;
        const accessToken = loginResponse.data.accessToken ?? loginResponse.data.token;
        const refreshToken = loginResponse.data.refreshToken ?? loginResponse.data.refresh_token ?? '';

        if (!loggedInUser || !accessToken) {
            throw new Error('Invalid login response. Please try again.');
        }

        setUserSession(loggedInUser, accessToken, refreshToken);
        setAccountCreated(true);
        return true;
    };

    const sessionMatchesFormEmail = () => {
        const sessionUser = getUser();
        const formEmail = (formData.email || '').trim().toLowerCase();
        if (!formEmail || !sessionUser?.username || !getAccessToken()) {
            return false;
        }
        return String(sessionUser.username).trim().toLowerCase() === formEmail;
    };

    const createAccountInBackground = () => {
        if (sessionMatchesFormEmail()) {
            setAccountCreated(true);
            void prefetchCheckoutSession();
            return Promise.resolve(true);
        }
        if (accountCreatePromiseRef.current) {
            return accountCreatePromiseRef.current;
        }

        setSubmitError(null);
        const createPromise = registerAndLogin()
            .then((ok) => {
                if (ok) {
                    void prefetchCheckoutSession();
                }
                return ok;
            })
            .catch((error) => {
                const apiMessage = error.response?.data?.message;
                if (error.response?.status === 401 || error.response?.status === 403) {
                    setSubmitError(apiMessage || 'Could not create account. Please try again.');
                } else if (error.message) {
                    setSubmitError(error.message);
                } else {
                    setSubmitError('Something went wrong. Please try again.');
                }
                setAccountCreated(false);
                setCurrentQuestion(1);
                return false;
            })
            .finally(() => {
                accountCreatePromiseRef.current = null;
            });

        accountCreatePromiseRef.current = createPromise;
        return createPromise;
    };

    const ensureAccountCreated = async () => {
        // Prefer an existing session before waiting on an in-flight create (avoids deadlock)
        if (getAccessToken() && getUser()?.username) {
            setAccountCreated(true);
            return true;
        }
        if (accountCreatePromiseRef.current) {
            return accountCreatePromiseRef.current;
        }
        if (sessionMatchesFormEmail()) {
            setAccountCreated(true);
            return true;
        }
        if ((formData.email || '').trim() && formData.newPassword) {
            return createAccountInBackground();
        }
        return false;
    };

    const handleNextQuestion = async () => {
        if (!validateStep(currentQuestion)) {
            return;
        }

        if (currentQuestion === 0) {
            if (accountCreated || getAccessToken()) {
                setAccountCreated(true);
                setCurrentQuestion(2);
                void prefetchCheckoutSession();
            } else {
                goNext();
            }
            return;
        }

        // Advance immediately; register + login continue in the background
        if (currentQuestion === 1) {
            goNext();
            if (!sessionMatchesFormEmail()) {
                void createAccountInBackground();
            } else {
                void prefetchCheckoutSession();
            }
            return;
        }

        // Last input step: advance immediately; submit onboarding in background
        // (checkout was already prefetched after account creation)
        if (currentQuestion === 11) {
            goNext();
            void (async () => {
                const ready = await ensureAccountCreated();
                if (ready) {
                    void submitOnboardingInBackground();
                }
            })();
            void ensureCheckoutSession();
            return;
        }

        goNext();
        // Keep checkout warm while user moves through remaining steps
        if (currentQuestion >= 1) {
            void ensureCheckoutSession();
        }
    };

    const handlePreviousQuestion = () => {
        goBack();
    };


    const homeHandler = () => {
        document.getElementById('learningContainer').style.display = 'none'
        document.getElementById('homeContainer').style.display = 'block'
    }


    const handleChatNavigate = () => {
        // Update the input value as the answer for the current question
        //console.log('navigate chat')
        navigate('/chat')
    };

    const submitOnboardingInBackground = () => {
        if (onboardingSubmitPromiseRef.current) {
            return onboardingSubmitPromiseRef.current;
        }
        if (onboardingSubmitStatus === 'success') {
            return Promise.resolve(true);
        }

        const finalInputStep = 11;
        if (!validateStep(finalInputStep)) {
            return Promise.resolve(false);
        }

        const sessionUser = getUser();
        const sessionToken = getAccessToken();
        if (!sessionUser || !sessionToken) {
            setSubmitError('Your session expired. Please create your account again.');
            setOnboardingSubmitStatus('error');
            setCurrentQuestion(1);
            setAccountCreated(false);
            return Promise.resolve(false);
        }

        setOnboardingSubmitStatus('pending');
        setSubmitError(null);

        const requestConfig = {
            headers: {
                'x-api-key': API_KEY
            }
        };

        const requestBody = {
            email: email || sessionUser.email || sessionUser.username || '',
            dateofbirth: dateofbirth,
            name: name,
            timeSpent: timeSpent,
            gender: gender,
            triedTreatments: triedTreatments,
            failureReasons: failureReasons,
            currentGoal: currentGoal,
            avoidDifficultThoughtsOrFeelings: caplanScaleMR3,
            missedSocialEngagementsDueToMentalWellness: caplanScaleNO2,
            struggleStayingPresentOrFocused: caplanScaleCIU3,
            mentalWellnessInterferesWithShowingUp: caplanScaleCIU1,
            difficultyRegulatingThoughtsEmotionsWhenOverwhelmed: caplanScaleMR2,
            unhelpfulCopingWhenFeelingDown: caplanScaleNO1,
            username: sessionUser.username || '',
            token: sessionToken,
            date: dateObj.getTime(),
            newPassword: newPassword,
            problematicBehaviors: problematicBehaviors,
            joiningReason: joiningReason,
            aboutYou: aboutYou,
            vizSuccess: vizSuccess,
            friendAdvice: friendAdvice,
            timeCommitment: timeCommitment,
            workoutTime: workoutTime,
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
        };

        const submitPromise = axios.post(onboardingrUrl, requestBody, requestConfig)
            .then(() => {
                console.log('onboardingsuccess');
                setOnboardingComplete(true);
                updateUser({ fieldName: name, name });
                setOnboardingSubmitStatus('success');
                return true;
            })
            .catch((error) => {
                const apiMessage = error.response?.data?.message;
                const status = error.response?.status;
                if (status === 401 || status === 403) {
                    setErrorMessage(apiMessage || 'Unauthorized. Please try again.');
                    setSubmitError(apiMessage || 'Something went wrong. Please try again.');
                } else {
                    setErrorMessage(apiMessage || 'Sorry the server is down. Please try again later.');
                    setSubmitError(apiMessage || error.message || 'Something went wrong. Please try again.');
                }
                setOnboardingSubmitStatus('error');
                return false;
            })
            .finally(() => {
                onboardingSubmitPromiseRef.current = null;
            });

        onboardingSubmitPromiseRef.current = submitPromise;
        return submitPromise;
    };

    const ensureOnboardingSubmitted = async () => {
        if (onboardingSubmitStatus === 'success') {
            return true;
        }
        if (onboardingSubmitPromiseRef.current) {
            return onboardingSubmitPromiseRef.current;
        }
        // idle or error: (re)submit and wait
        return submitOnboardingInBackground();
    };

    const handleOpenonboardingPopup = () => {
        setShowPopup(true);
        const hasSession = !!getAccessToken();
        setAccountCreated(hasSession);
        setCurrentQuestion(hasSession ? 2 : 0);
        document.getElementById('onboarding-popup').style.display = "block";
        document.getElementsByClassName("popupContainer")[0].style.visibility =  "visible"
        document.getElementsByClassName("popupButtonGroup")[0].style.visibility =  "visible"
        if (hasSession) {
            void prefetchCheckoutSession();
        }
    };

    const handleCloseonboardingPopup = () => {
        setShowPopup(false);
        setCurrentQuestion(0); // Reset the current question when the popup is closed
        setAnswers([]); // Clear the answers when the popup is closed
        setCheckoutClientSecret(null);
        setCheckoutError(null);
        setIsPrefetchingCheckout(false);
        checkoutPrefetchPromiseRef.current = null;
        document.getElementsByClassName("popupContainer")[0].style.display =  "none"
        document.getElementsByClassName("popupContainer")[0].style.visibility =  "hidden"

    };

    const handleCloseRelapsePopup = () => {
        const header = document.querySelector('.header');
        if (header) {
            header.style.display = 'block';
        }
        navigate('/daily-content', { state: { fromOnboarding: true } });
    }

    const prefetchCheckoutSession = () => {
        if (checkoutClientSecret) {
            return Promise.resolve(checkoutClientSecret);
        }
        if (checkoutPrefetchPromiseRef.current) {
            return checkoutPrefetchPromiseRef.current;
        }

        if (!stripePromise) {
            setCheckoutError('Billing setup unavailable. Missing Stripe publishable key.');
            return Promise.resolve(null);
        }

        setCheckoutError(null);
        setIsPrefetchingCheckout(true);

        // Checkout only needs an authenticated user — do not wait on onboarding submit
        const prefetchPromise = (async () => {
            const accountReady = await ensureAccountCreated();
            if (!accountReady || !getAccessToken() || !getUser()) {
                // Account may still be creating; caller can retry later via ensureCheckoutSession
                return null;
            }

            const returnUrl = `${window.location.origin}/daily-content?checkout=success`;
            const clientSecret = await createEmbeddedCheckoutSession(returnUrl);
            setCheckoutClientSecret(clientSecret);
            return clientSecret;
        })()
            .catch((error) => {
                const apiMessage = error.response?.data?.message;
                setCheckoutError(
                    apiMessage
                    || error.message
                    || 'Billing setup unavailable. Please try again later.'
                );
                return null;
            })
            .finally(() => {
                checkoutPrefetchPromiseRef.current = null;
                setIsPrefetchingCheckout(false);
            });

        checkoutPrefetchPromiseRef.current = prefetchPromise;
        return prefetchPromise;
    };

    const ensureCheckoutSession = () => {
        if (checkoutClientSecret) {
            return Promise.resolve(checkoutClientSecret);
        }
        if (checkoutPrefetchPromiseRef.current) {
            return checkoutPrefetchPromiseRef.current;
        }
        return prefetchCheckoutSession();
    };


    const renderFormonboarding = () => {
        try{
            const currentQ = questionsonboarding[currentQuestion];
            const { question, options } = currentQ;
            const isCtaStep = currentQuestion === questionsonboarding.length - 1;
            const preloadCheckoutStep = questionsonboarding.length - 2; // step 13: warm embed one screen before CTA
            const shouldMountCheckout = currentQuestion >= preloadCheckoutStep;

            return (
                <div className="formContainer">
                    <div className="landing-onboarding-sheet__header">
                        {(currentQuestion > 0 && currentQuestion < questionsonboarding.length - 1) ? (
                            <button type="button" className="landing-onboarding-top-back" onClick={handlePreviousQuestion} aria-label="Previous step">
                                {backArrowIcon}
                            </button>
                        ) : <span aria-hidden="true" />}
                        <button type="button" className="landing-onboarding-top-close" onClick={handleCloseonboardingPopup} aria-label="Close onboarding">
                            x
                        </button>
                    </div>
                    <div className="landing-onboarding-sheet__body">
                        <div className="landing-onboarding-sheet__body-inner">
                            <h2 className="onboarding-popup-title">{question}</h2>
                            <div className="landing-onboarding-sheet__assets">
                                {currentQ.assets}
                            </div>
                            {/* Mount Stripe only near CTA so Link/SMS does not fire during early steps */}
                            <div className={`landing-checkout-host${isCtaStep ? ' is-cta' : ''}`} aria-hidden={!isCtaStep}>
                                {shouldMountCheckout && checkoutClientSecret && stripePromise ? (
                                    <EmbeddedCheckoutProvider
                                        stripe={stripePromise}
                                        options={{ clientSecret: checkoutClientSecret }}
                                    >
                                        <EmbeddedCheckout />
                                    </EmbeddedCheckoutProvider>
                                ) : null}
                                {isCtaStep && !checkoutClientSecret ? (
                                    <div style={{ padding: '1rem 0', textAlign: 'center' }}>
                                        {checkoutError ? (
                                            <>
                                                <p
                                                    style={{
                                                        color: 'rgba(196,90,90,0.95)',
                                                        fontSize: '12px',
                                                        marginBottom: '12px',
                                                        fontFamily: 'DM Sans, sans-serif'
                                                    }}
                                                >
                                                    {checkoutError}
                                                </p>
                                                <button
                                                    type="button"
                                                    className="popupButton"
                                                    onClick={() => { void prefetchCheckoutSession(); }}
                                                >
                                                    Retry
                                                </button>
                                            </>
                                        ) : (
                                            <p
                                                style={{
                                                    color: 'rgba(255,255,255,0.7)',
                                                    fontSize: '14px',
                                                    fontFamily: 'DM Sans, sans-serif'
                                                }}
                                            >
                                                Preparing your free trial…
                                            </p>
                                        )}
                                    </div>
                                ) : null}
                            </div>
                            {isCtaStep ? (
                                <button
                                    type="button"
                                    style={{ marginTop: '0.75rem', border: 'none', background: 'transparent', color: 'rgba(255,255,255,0.8)', fontSize: '14px', textDecoration: 'underline', cursor: 'pointer' }}
                                    className="popupButton"
                                    onClick={() => { window.open(MAILING_LIST_URL, '_blank'); }}
                                >
                                    Not sure yet? Join mailing list
                                </button>
                            ) : null}
                        </div>
                    </div>
                    <div className="popupButtonGroup landing-onboarding-sheet__footer">
                        {submitError ? (
                            <p
                                style={{
                                    color: 'rgba(196,90,90,0.9)',
                                    fontSize: '11px',
                                    marginTop: '6px',
                                    fontFamily: 'DM Sans, sans-serif'
                                }}
                            >
                                {submitError}
                            </p>
                        ) : null}
                        {currentQuestion === 0 ? (
                            <button type="button" className="homeBttn onboarding-pill-btn onboarding-pill-btn--text" onClick={handleNextQuestion}>
                                Jump in!
                            </button>
                        ) : null}
                        {currentQuestion > 0 && currentQuestion < questionsonboarding.length - 1 ? (
                            <button
                                type="button"
                                className="homeBttn onboarding-pill-btn"
                                onClick={handleNextQuestion}
                                aria-label="Next step"
                            >
                                {nextArrowIcon}
                            </button>
                        ) : null}
                    </div>
                </div>
            );
        }
        catch{
            //console.log('someerro yo onboarding')
        }
    };
    
    // End of Popup
    
    const timeElapsed = Date.now();
    const today = new Date(timeElapsed);
    const todayString = today.toDateString();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        const sessionUser = getUser();
        const header = document.querySelector('.header');
        if (sessionUser?.onboardingComplete && getAccessToken()) {
            if (header) {
                header.style.display = 'block';
            }
            navigate('/daily-content');
            return;
        }
        if (header) {
            header.style.display = 'none';
        }
    }, []);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        setOnboardingForm()
     }, [formData, relapsePlanText, submitError]);

    useEffect(() => {
        setOnboardingForm()
    }, [errors]);

    // Warm checkout as soon as popup opens with a session; keep ensuring on later steps
    useEffect(() => {
        if (!showPopup) {
            return undefined;
        }
        if (getAccessToken() || currentQuestion >= 1) {
            void ensureCheckoutSession();
        }
        return undefined;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showPopup, currentQuestion]);

    useEffect(() => {
        if (!showPopup) {
            return undefined;
        }
        const prevBody = document.body.style.overflow;
        const prevHtml = document.documentElement.style.overflow;
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = prevBody;
            document.documentElement.style.overflow = prevHtml;
        };
    }, [showPopup]);

    return (
        <div className="wrapper" style={{ minHeight: '100dvh', margin: 0, padding: '32px 24px 20px', boxSizing: 'border-box' }}>
            <div className="dailyPopup">
                {/* <button onClick={handleOpenPopup}>hello</button> */}
                {/* #4490C3 */}
                <div className="popupContainer"  id="onboarding-popup"  style={{ display: 'none' }}>{renderFormonboarding()}</div>
            </div>
            <div className="container" id="learningContainer" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minHeight: 'calc(100dvh - 52px)', width: '100%' }}>
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', minHeight: 0 }}>
                    <div style={{ textAlign: 'center', maxWidth: '640px' }}>
                        <h2 style={{ paddingBottom: '5rem', fontFamily: "'Fraunces', serif", fontWeight: 300, color: '#FFFFFF', lineHeight: 1.2, letterSpacing: '-0.3px', marginBottom: '1.1rem', textShadow: '0 2px 12px rgba(0,0,0,0.4)' }}>
                            Your emotional fitness <br/> journey starts here.
                        </h2>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', maxWidth: '700px', fontSize: '0.95rem', textAlign: 'center', color: 'rgba(255,255,255,0.86)', rowGap: '0.55rem' }}>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "0.2rem 0.5rem" }}>
                            <svg className="mr-2 h-6 w-6 text-green-500" fill="none" height="24" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><polyline points="20 6 9 17 4 12"></polyline></svg>
                            <span className="text-lg font-medium" style={{ padding: "0.5rem" }}>Create Sustainable Longterm Change</span>
                        </div>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "0.2rem 0.5rem" }}>
                            <svg className="mr-2 h-6 w-6 text-green-500" fill="none" height="24" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><polyline points="20 6 9 17 4 12"></polyline></svg>
                            <span className="text-lg font-medium" style={{ padding: "0.5rem" }}>Find Community, Accountability, and Support</span>
                        </div>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "0.2rem 0.5rem" }}>
                            <svg className="mr-2 h-6 w-6 text-green-500" fill="none" height="24" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><polyline points="20 6 9 17 4 12"></polyline></svg>
                            <span className="text-lg font-medium" style={{ padding: "0.5rem" }}>Spend Your Time with More Intention</span>
                        </div>
                    </div>
                </div>
                <div className="homeBttnContainer" style={{ display: 'flex', flexDirection: 'column', position: 'relative', textAlign: 'center', justifyContent: "center", alignItems: 'center', flexShrink: 0, width: '100%', maxWidth: '420px', paddingTop: '1.5rem' }}>
                    <h6 style={{ marginBottom: '0.8rem', color: 'rgba(255,255,255,0.7)', fontWeight: 400 }}>Growing is hard but now you're not alone.</h6>
                    <button className="homeBttn" style={{ marginTop: '0.25rem', background: 'transparent', border: '1px solid rgba(255,255,255,0.45)', borderRadius: '50px', color: '#FFFFFF', maxWidth: '420px', width: '100%', marginBottom: '0.2rem', fontSize: '15px', fontWeight: 500 }} onClick={handleOpenonboardingPopup}>Get Started </button>
                </div>
            </div>
            
        </div>
    )
}


export default LandingForm;
